// @ts-nocheck
import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguageContext } from "../context/languageContext";

const ServiceDetailCard = ({ product, categoryItems = [] }) => {
    const navigate = useNavigate();
    const { language, t } = useLanguageContext();

    const getTranslatedName = () => {
        if (!product?.itemTranslation) return product.name;
        const map = {
            en: product.itemTranslation.englishName,
            it: product.itemTranslation.italianName,
            sq: product.itemTranslation.albanianName,
            de: product.itemTranslation.germanName,
            es: product.itemTranslation.spanishName,
            pl: product.itemTranslation.polishName,
            ukr: product.itemTranslation.ukrainianName,
        };
        return map[language] || product.name;
    };

    const getTranslatedDescription = () => {
        if (!product?.itemTranslation) return product.description;
        const map = {
            en: product.itemTranslation.englishDescription,
            it: product.itemTranslation.italianDescription,
            sq: product.itemTranslation.albanianDescription,
            de: product.itemTranslation.germanDescription,
            es: product.itemTranslation.spanishDescription,
            pl: product.itemTranslation.polishDescription,
            ukr: product.itemTranslation.ukrainianDescription,
        };
        return map[language] || product.description;
    };

    const handleRequestService = () => {
        navigate(`/room-service/services/${product.id}`, {
            state: { product, categoryItems }
        });
    };

    return (
        <div
            onClick={handleRequestService}
            className="group cursor-pointer bg-white rounded-2xl shadow-sm hover:shadow-xl border border-slate-100 overflow-hidden transition-all duration-300 hover:-translate-y-1"
        >
            {/* Image Section */}
            <div className="relative h-32 sm:h-44 overflow-hidden">
                <img
                    src={product.serviceItemImageUrl}
                    alt={getTranslatedName()}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                />
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>

                {/* Price Tag */}
                {/* <div className="absolute top-3 right-3 bg-white rounded-full px-2.5 py-1 shadow-md">
                    <span className="text-xs font-bold text-slate-800">{product.euroPrice}€</span>
                </div> */}

                {/* Title on Image */}
                <div className="absolute bottom-0 left-0 right-0 p-3">
                    <h3 className="text-white font-semibold text-sm sm:text-base line-clamp-1 drop-shadow-md">
                        {getTranslatedName()}
                    </h3>
                </div>
            </div>

            {/* Content */}
            <div className="p-3 sm:p-4">
                <p className="text-slate-500 text-xs line-clamp-2 mb-3 leading-relaxed">
                    {getTranslatedDescription()}
                </p>

                {/* Action Row */}
                <div className="flex items-center justify-between">
                    <span className="text-xs text-slate-400">{product.price} ALL</span>
                    <span className="inline-flex items-center gap-1 text-xs font-medium text-indigo-600 group-hover:text-indigo-700">
                        {t("Request")}
                        <svg className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ServiceDetailCard;
